import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import url from 'url';
import { PAGE_LAYOUT_TYPE } from '../../modules/types';
import { isDefaultLocale } from '../../modules/i18n/locales';
import useQuery from '../../modules/react/hooks/useQuery';
import Breadcrumbs from '../components/stateless/Breadcrumbs';

export const GET_BREADCRUMB_TRAIL = gql`
  query GetBreadcrumbTrail($pageId: ID!) {
    page(id: $pageId) {
      id
      title
      locale
      pageType {
        code
      }
      breadcrumbTrail {
        id
        name
        ancestorPages {
          id
          title
          path
          live
          breadcrumbTrail {
            id
            name
          }
        }
      }
    }
    currentCompany {
      id
      name
    }
    currentSite {
      id
      siteUrl
      customCompanyName
    }
  }
`;

const propTypes = {
  pageId: PropTypes.string,
  companyName: PropTypes.string,
};

const defaultProps = {
  pageId: '',
  companyName: '',
};

const PageBreadcrumbTrail = ({
  pageId,
  companyName,
}) => {
  // If no pageId provided assume we are on a layout
  if (!pageId) {
    return (
      <Breadcrumbs
        name={companyName}
        pageType={{ code: PAGE_LAYOUT_TYPE }}
      />
    );
  }

  const { data } = pageId && useQuery(
    GET_BREADCRUMB_TRAIL,
    { variables: { pageId } },
  );

  if (!data || !data.page) {
    return null;
  }

  const {
    page: {
      title,
      breadcrumbTrail,
      pageType,
      locale,
    },
    currentSite: {
      siteUrl,
      customCompanyName,
    },
  } = data;

  const currentPageDisplayName = (breadcrumbTrail && breadcrumbTrail.name) || title;

  let breadcrumbTrailWithHomePage = [{
    title: customCompanyName,
    slug: isDefaultLocale(locale) ? siteUrl : `${siteUrl}/${locale}`,
  }];
  if (breadcrumbTrail && breadcrumbTrail.ancestorPages && breadcrumbTrail.ancestorPages.length) {
    breadcrumbTrailWithHomePage = breadcrumbTrailWithHomePage.concat(
      breadcrumbTrail.ancestorPages
        .filter(({ live }) => live)
        .map((ancestor) => {
          const result = { slug: url.resolve(siteUrl, ancestor.path) };
          result.title = ancestor.breadcrumbTrail
            ? ancestor.breadcrumbTrail.name
            : ancestor.title;
          return result;
        }),
    );
  }
  return (
    <Breadcrumbs
      name={currentPageDisplayName}
      breadcrumbTrail={breadcrumbTrailWithHomePage}
      pageType={pageType}
    />
  );
};

PageBreadcrumbTrail.propTypes = propTypes;
PageBreadcrumbTrail.defaultProps = defaultProps;

export default PageBreadcrumbTrail;
